export const selectSearchResults = state => state.getIn(['globalSearch', 'searchResults']);

export const selectSearchResultsLoading = state =>
  state.getIn(['globalSearch', 'isSearchResultsLoading']);
